import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "src/app/components/components.module";
import { DepositECheckBasePage } from "./deposit-e-check-base";


@NgModule({
  declarations: [DepositECheckBasePage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
})
export class DepositECheckBasePageModule {}